import type { InstitutionTheme } from '../types';
import { foothillColors } from './colors';

// Foothill College institutional theme (W52 Worker F, S3).
//
// Brand strings from the college site; "MyPortal" is the Foothill–De Anza district
// student portal (foothill.edu/catalog/ navigation). Colors per ./colors.ts (Foothill
// Red + Foothill Yellow, from the 2026-2027 brand guide).
//
// Example course codes are the three code SHAPES the S0 probe walk found
// (onboarding/foothill/probes/course_index_s0.json): MATH 1A (letter-suffixed),
// ENGL C1000 (Common Course Number, printed in the C form), C S 1A (one of the six
// spaced two-letter prefixes). First entry is the primary example.
export const foothillTheme: InstitutionTheme = {
  slug: 'foothill',
  universityName: 'Foothill College',
  universityShortName: 'Foothill',
  registrationPortalName: 'MyPortal',
  exampleCourseCodes: ['MATH 1A', 'ENGL C1000', 'C S 1A'],
  colors: foothillColors,
};
